import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Utils } from 'poly-js-utils';
import { connectToJSContext, RA_73_STERILIZE_HTML_STRING } from '../utils.jsx';
import SectionHeader from '../section_header/index.jsx';
import { LinkPost, ImagePost, TextPost } from './posts.jsx';
import { checkEmptyState } from '../helpers';
import { POST_LIST } from '../constants';
import { visiblePostsList } from './utils';

const PostList = props => {
    const {
        posts,
        postsLength,
        newsEmptyTextState,
        limit,
        imagePostHover,
        linkPostHover,
        defaultPostHover,
        title,
        headerTagline,
        showTagline,
        hideNewsOverlay,
        urlSlug,
        buttonText,
        buttonLabel,
        switchRenderingOrder,
        showHeader,
        sectionId
    } = props;
    const visiblePosts = visiblePostsList(posts, limit);
    const buttonAttributes = {
        "data-post-name": "",
        "data-click-type": "posts-view-all"
    };
    const headerProps = {
        title,
        urlSlug,
        buttonText,
        buttonLabel,
        sectionId,
        buttonAttributes,
        switchRenderingOrder: switchRenderingOrder
    };

    if (showTagline) {
        headerProps.tagline = headerTagline;
    }

    return (
        <div className="c-post hs-section">
            {showHeader && (postsLength || newsEmptyTextState) &&
                <SectionHeader {...headerProps} />
            }
            <div id="posts">
                <div className="hs-posts container">
                    <div className="row">
                        {!visiblePosts || !visiblePosts.length ?
                            <div className="col-xs-12">
                                <p
                                    dangerouslySetInnerHTML={{
                                        __html: RA_73_STERILIZE_HTML_STRING(newsEmptyTextState)
                                    }}
                                />
                            </div>
                            :
                            visiblePosts.map((post) => {
                                if (post.link) {
                                    return (
                                        <LinkPost
                                            key={post.id}
                                            {...post}
                                            linkPostHover={linkPostHover}
                                            hideNewsOverlay={hideNewsOverlay}
                                        />
                                    );
                                } else if (post.image) {
                                    return <ImagePost key={post.id} {...post} imagePostHover={imagePostHover} />;
                                } else if (post.message && !post.image && !post.link) {
                                    return <TextPost key={post.id} {...post} defaultPostHover={defaultPostHover} />;
                                }
                                return <div key={post.id} />;
                            })
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

PostList.propTypes = {
    posts: PropTypes.arrayOf(
        PropTypes.shape({
            link: PropTypes.string,
            image: PropTypes.string,
            linkTitle: PropTypes.string,
            linkSummary: PropTypes.string,
            message: PropTypes.string
        })
    ),
    newsEmptyTextState: PropTypes.string,
    limit: PropTypes.number,
    imagePostHover: PropTypes.string,
    linkPostHover: PropTypes.string,
    defaultPostHover: PropTypes.string,
    title: PropTypes.string,
    showTagline: PropTypes.bool,
    hideNewsOverlay: PropTypes.bool,
    urlSlug: PropTypes.string,
    buttonText: PropTypes.string,
    buttonLabel: PropTypes.string,
    showHeader: PropTypes.bool
};

PostList.defaultProps = {
    showHeader: POST_LIST.DEFAULT_PROPS.SHOW_HEADER,
    hideNewsOverlay: POST_LIST.DEFAULT_PROPS.HIDE_OVERLAY
};

// for testing
export { PostList };

const mapStateToProps = (state) => {
    // eslint-disable-next-line underscore/matches-shorthand
    const newsUrl = _.find(state.theme_data.nav.main_navigation_links, (link) => link.url === 'news');
    return {
        posts: (state.posts || []).map((postData) => ({
            id: postData.id,
            image: postData.image,
            link: postData.link,
            linkSummary: postData.link_summary,
            linkTitle: postData.link_title,
            message: postData.message
        })),
        newsEmptyTextState: checkEmptyState(state.theme_data.news_page.empty_state_text),
        imagePostHover: state.theme_data.news_page.news_image_post_hover || undefined,
        linkPostHover: state.theme_data.news_page.news_link_post_hover || undefined,
        defaultPostHover: state.theme_data.news_page.default_link_post_hover || undefined,
        title: state.theme_data.news_page.header_title,
        headerTagline: state.theme_data.news_page.header_tagline,
        showTagline: Utils.selectBoxIsTrue(state.theme_data.home_page.is_tagline_included_in_home_page),
        hideNewsOverlay: Utils.selectBoxIsTrue(state.theme_data.news_page.hide_news_overlay),
        urlSlug: newsUrl && newsUrl.url,
        buttonText: state.theme_data.news_page.view_more_text || undefined,
        buttonLabel: state.theme_data.news_page.view_more_label || undefined,
        switchRenderingOrder: Utils.selectBoxIsTrue(state.theme_data.news_page.switch_rendering_order),
        postsLength: state.posts ? state.posts.length : 0,
        sectionId: 'news'
    };
};

export default connectToJSContext(mapStateToProps)(PostList);



// WEBPACK FOOTER //
// ./components/post_list/index.jsx